import { Injectable } from '@angular/core';

const drivingLicenseEmployeeToVacancy = {
  G: ['G', 'B', 'A3', 'NONE'],
  DE: ['DE', 'D', 'D1', 'D1E', 'B', 'A3', 'NONE'],
  D: ['D', 'D1', 'B', 'A3', 'NONE'],
  D1E: ['D1E', 'D1', 'B', 'A3', 'NONE'],
  D1: ['D1', 'B', 'A3', 'NONE'],
  CE: ['CE', 'C', 'C1', 'C1E', 'B', 'A3', 'NONE'],
  C: ['C', 'C1', 'B', 'A3', 'NONE'],
  C1E: ['C1E', 'C1', 'B', 'A3', 'NONE'],
  C1: ['C1', 'B', 'A3', 'NONE'],
  BE: ['BE', 'B', 'A3', 'NONE'],
  B: ['B', 'A3', 'NONE'],
  A: ['A', 'A3', 'NONE'],
  A3: ['A3', 'NONE'],
  INTERNATIONAL: [],
};

const drivingLicenseVacancyToEmployee = {
  G: ['G'],
  DE: ['DE'],
  D: ['D', 'DE'],
  D1E: ['D1E', 'DE'],
  D1: ['D1', 'D1E', 'D', 'DE'],
  CE: ['CE'],
  C: ['C', 'CE'],
  C1E: ['C1E', 'CE'],
  C1: ['C1', 'C1E', 'C', 'CE'],
  BE: ['BE'],
  B: ['B', 'BE', 'C1', 'C1E', 'C', 'CE', 'D1', 'D1E', 'D', 'DE', 'G'],
  A: ['A'],
  A3: ['A3', 'A', 'B', 'BE', 'C1', 'C1E', 'C', 'CE', 'D1', 'D1E', 'D', 'DE', 'G'],
  INTERNATIONAL: [],
};

@Injectable({
  providedIn: 'root',
})
export class MatchingDrivingLicenseService {
  constructor() {}

  getDrivingLicenseForEmployee(licenseList: string[]): string[] {
    let licenseSet: Set<string> = licenseList.reduce((acc: Set<string>, val) => {
      let licensies: string[] = drivingLicenseVacancyToEmployee[val] || [];
      licensies.forEach(v => acc.add(v));
      return acc;
    }, new Set() as Set<string>);
    return [...licenseSet];
  }

  getDrivingLicenseForVacancy(licenseList: string[]): string[] {
    let licenseSet: Set<string> = licenseList.reduce((acc: Set<string>, val) => {
      let licensies: string[] = drivingLicenseEmployeeToVacancy[val] || [];
      licensies.forEach(v => acc.add(v));
      return acc;
    }, new Set() as Set<string>);
    return [...licenseSet];
  }
}
